export enum ServiceEnum {
    Webtrader = 'Webtrader',
    MedicinalProducts = 'MedicinalProducts',
    Meddra = "Meddra"
}